import React from "react"
import { Alert } from "react-bootstrap"
import { useTranslation } from "react-i18next"
import { config } from "@src/constants"
import { usePartnerAccess } from "./hooks/usePartnerAccess"
import { UsersTable } from "./components"

export const PartnerAccessScreen: React.FC = () => {
  const { t } = useTranslation()
  const { userRoles } = usePartnerAccess()

  return (
    <div>
      <Alert variant="info" className="mb-4">
        <Alert.Heading>{t("settings.partner.tabs.user_access_management")}</Alert.Heading>
        <p className="mb-0">
          {t("settings.partner.tabs.contact_customer_care")}{" "}
          <a href={`mailto:${config.customerCareEmail}`} className="alert-link">
            {t("settings.partner.tabs.customer_care_team")}
          </a>
          {t("settings.partner.tabs.customer_care_assistance")}
        </p>
      </Alert>

      <UsersTable userRoles={userRoles} />
    </div>
  )
}
